<template lang="pug">
  .main-container.width-100.row
    .colum.menu-container
        button.tab.small-text.width-100(
          v-for='tab in tabs'
          :key='tab'
          :class='{ active: activeTab === tab, hide: (tab === tabs.kimpleFolders && isCustom) }'
          @click='setActiveTab(tab)'
          type='button'
        ) {{ $t(`folders.tabs.${tab}`) }}
    .column.section-container.width-100
      .row.space-between.m4-top-8
        h2.row.text-big.black.bold {{ $t(`folders.tabs.${activeTab}`) }}
        button.primary-button.with-icon(v-if='isOwnerTab' type='button' @click='handleCreate')
          simple-svg.white-icon.m-right-1(:filepath='createFolderIcon' :width='"20px"' :height='"20px"')
          | {{ $t('folders.createFolder') }}
      .m-bottom-4(v-if='isKimpleFolderTab && (kimpleFolders.length || kimpleFoldersLoading)')
        transition-group.grid.grid-columns-3.gap-20.m-top-3(name="fade" tag='div')
          kimple-folder-feed.m-bottom-2(
            v-for='kimpleFolder in kimpleFolders'
            :key='kimpleFolder.id'
            :folder='kimpleFolder'
            noMargin
            origin='Kimple folders list'
          )
      .m-bottom-4(v-if='!isKimpleFolderTab && (folders.length || foldersLoading)')
        transition-group.grid.grid-columns-3.gap-20.m-top-3(name="fade" tag='div')
          folder.folder(
            v-for='folder in folders'
            :key='folder.id'
            :folder='folder'
            noMargin
            :shared='userId !== folder.ownerId'
            :hasEditPermission='folder.permission !== FOLDER_PERMISSIONS.read'
          )
      .empty-list.item-1(v-if='folders.length == 0 && isOwnerTab')
        lottie(:options='folderOptions' :height='"144px"' :width='"224px"')
        simple-svg(:filepath='emptyIlustration' :width='"230px"' :height='"145px"')
        h2.title-medium.bold.dark-gray.m-top-3 {{ $t('folders.noFolders') }}
        p.text-big.dark-gray.m-top-2 {{ $t('folders.clasifyResources') }}
        router-link.text-small.blue.m-top-3(to='/feed') {{ $t('folders.exploreResources') }}
      .empty-list.item-1(v-if='folders.length == 0 && isSharedTab')
        simple-svg(:filepath='emptySharedIlustration' width="230px" height="145px")
        h2.title-medium.bold.dark-gray.m-top-3 {{ $t('folders.noSharedFolders') }}
        p.text-big.dark-gray.m-top-2 {{ $t('folders.noSharedFoldersDescription') }}
    folder-create-modal(v-if='showCreateModal' :onFolderCreated='onFolderCreated')
    folder-share-modal(v-if='showShareModal')
    create-sharing-group-modal(v-if='showCreateSharingGroupModal')
    edit-sharing-group-modal(v-if='showEditSharingGroupModal')
    add-sharing-group-members-modal(v-if='showAddSharingGroupMembersModal')
    choice-modal(v-if='showChoiceModal')
    add-resource-modal(v-if='showAddResourceModal')
    remove-resource-modal(v-if='showRemoveResourceModal' :text='$t("removeResource.text")' @reload='reloadFolders')
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Lottie from 'vue-lottie'
import amplitude from 'amplitude-js'

import Folder from '@/components/Folders/Folder'
import ResourceCard from '@/components/ResourceCard'
import AddResourceModal from '@/components/Resource/AddResource'
import Carousel from '@/components/Carousel'
import FolderCreateModal from '@/components/Folders/FolderCreateModal'
import FolderShareModal from '@/components/Folders/FolderShareModal'
import RemoveResourceModal from '@/components/RemoveResourceModal'
import KimpleFolderFeed from '@/components/KimpleFolderFeed'
import CreateSharingGroupModal from '@/components/Modals/CreateSharingGroupModal'
import EditSharingGroupModal from '@/components/Modals/EditSharingGroupModal'
import ChoiceModal from '@/components/Modals/ChoiceModal'
import AddSharingGroupMembersModal from '@/components/Modals/AddSharingGroupMembersModal'

import userRole from '@/mixins/userRole'
import emptyIlustration from '@/assets/lottie/folder.json'
import createFolderIcon from '@/assets/ic_new-folder.svg'
import emptySharedIlustration from '@/assets/il_empty_shared_folder.svg'

import { FOLDER_PERMISSIONS, foldersTabs, myFoldersTab, kimpleFoldersTab } from '@/constants/folders'
import { sharedWithMe } from '../constants/folders'

export default {
  name: 'folders',
  mixins: [userRole],
  props: {
    rootTab: { type: String, default: kimpleFoldersTab }
  },
  components: {
    ChoiceModal,
    CreateSharingGroupModal,
    AddSharingGroupMembersModal,
    EditSharingGroupModal,
    Lottie,
    Folder,
    ResourceCard,
    Carousel,
    FolderCreateModal,
    FolderShareModal,
    RemoveResourceModal,
    AddResourceModal,
    KimpleFolderFeed
  },
  data() {
    return {
      createFolderIcon,
      emptyIlustration,
      emptySharedIlustration,
      folderOptions: { animationData: emptyIlustration },
      FOLDER_PERMISSIONS,
      tabs: foldersTabs,
      myFoldersTab,
      kimpleFoldersTab,
      activeTab: this.rootTab,
      toastError: false,
      toastMessage: ''
    }
  },
  computed: {
    ...mapState({
      folders: state => state.folders.folders,
      foldersLoading: state => state.folders.foldersLoading,
      kimpleFolders: state => state.kimpleFolders.kimpleFolders,
      kimpleFoldersLoading: state => state.kimpleFolders.kimpleFoldersLoading,
      userId: state => state.userInfo.userInfo.userId,
      showCreateSharingGroupModal: state => state.behavior.createSharingGroupModal.show,
      showAddSharingGroupMembersModal: state => state.behavior.addSharingGroupMembersModal.show,
      showEditSharingGroupModal: state => state.behavior.editSharingGroupModal.show,
      showCreateModal: state => state.behavior.folderCreateModal.show,
      showShareModal: state => state.behavior.folderShareModal.show,
      showAddResourceModal: state => state.behavior.addResourceModal.show,
      showRemoveResourceModal: state => state.behavior.removeResourceModal.show,
      locale: state => state.behavior.locale,
      showChoiceModal: state => state.behavior.choiceModal.show
    }),
    isOwnerTab() {
      return this.activeTab === myFoldersTab
    },
    isKimpleFolderTab() {
      return this.activeTab === kimpleFoldersTab
    },
    isSharedTab() {
      return this.activeTab === sharedWithMe
    },
    toastStyles() {
      return {
        width: '100%',
        display: 'flex',
        left: '0',
        'justify-content': 'center'
      }
    }
  },
  watch: {
    locale() {
      this.reloadKimpleFolders()
      this.reloadFolders()
    },
    activeTab(newValue, oldValue) {
      amplitude.getInstance().logEvent('Page access', {
        to: newValue,
        from: oldValue,
        redirect: false,
        publicPage: false
      })
    }
  },
  async created() {
    await this.setActiveTab(this.getActiveTab())
    this.hydrateKimpleFolders()
    this.hydrateFolders({ owner: this.isOwnerTab })
  },
  methods: {
    ...mapActions(['hydrateFolders', 'hydrateKimpleFolders', 'showElement']),
    handleCreate() {
      this.showElement({ element: 'folderCreateModal' })
    },
    reloadKimpleFolders() {
      this.hydrateKimpleFolders()
    },
    reloadFolders() {
      this.hydrateFolders({ owner: this.isOwnerTab })
    },
    setActiveTab(tab) {
      this.activeTab = tab
      this.isKimpleFolderTab ? this.reloadKimpleFolders() : this.reloadFolders()
    },
    onFolderCreated() {
      this.isOwnerTab = true
      amplitude.getInstance().logEvent('Folder created', { section: 'Folders section' })
      this.reloadFolders()
    },
    getActiveTab() {
      if (this.isCustom) return myFoldersTab
      return this.rootTab ? this.rootTab : this.kimpleFoldersTab
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/variables/sizes';
@import '../scss/variables/colors';

.menu-container {
  width: 192px;
}

.tab {
  height: 42px;
  text-align: left;
  padding: 0 10px;

  &.active {
    color: $blue;
    font-weight: bold;
    border-right: 3px solid $blue;
    background-color: $zircon-gray;
  }
  &.hide {
    display: none;
  }
}

.section-container {
  background-color: $zircon-gray;
  padding: 0 60px;
  min-height: calc(100vh - (#{$navbar-height} + #{$footer-height}));
}

.folders-container {
  margin: 0 auto;
  max-width: $content-size;
  min-height: calc(100vh - #{$footer-height});
}

.folder {
  min-height: 323px;
}

.empty-list {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateX(-50px);
}
</style>
